// Stubs for contract API endpoints that don't exist yet.
// Each matches the useMutation signature so the swap is a one-line import change.

import { useMutation } from '@tanstack/vue-query';
import type { UseMutationOptions, UseMutationReturnType } from '@tanstack/vue-query';

export interface ContractComment {
  id: string;
  text: string;
  author: string;
  created_at: string;
  is_system: boolean;
}

// TODO: Replace with real hook when GET /api/contract/:id/comments exists
export const useFetchContractComments = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<ContractComment[], TError, { contractId: string }, TContext>;
  },
): UseMutationReturnType<ContractComment[], TError, { contractId: string }, TContext> => {
  return useMutation({
    mutationFn: async ({ contractId }: { contractId: string }) => {
      console.warn(`[STUB] GET /api/contract/${contractId}/comments`);
      await new Promise((r) => setTimeout(r, 200));
      return [] as ContractComment[];
    },
    ...options?.mutation,
  });
};

// TODO: Replace with real hook when POST /api/contract/:id/comments exists
export const useAddContractComment = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<ContractComment, TError, { contractId: string; text: string }, TContext>;
  },
): UseMutationReturnType<ContractComment, TError, { contractId: string; text: string }, TContext> => {
  return useMutation({
    mutationFn: async ({ contractId, text }: { contractId: string; text: string }) => {
      console.warn(`[STUB] POST /api/contract/${contractId}/comments`, { text });
      await new Promise((r) => setTimeout(r, 300));
      return {
        id: crypto.randomUUID(),
        text,
        author: 'Current User',
        created_at: new Date().toISOString(),
        is_system: false,
      };
    },
    ...options?.mutation,
  });
};

// TODO: Replace with real hook when DELETE /api/contract/:id/comments/:commentId exists
export const useDeleteContractComment = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<void, TError, { contractId: string; commentId: string }, TContext>;
  },
): UseMutationReturnType<void, TError, { contractId: string; commentId: string }, TContext> => {
  return useMutation({
    mutationFn: async ({ contractId, commentId }: { contractId: string; commentId: string }) => {
      console.warn(`[STUB] DELETE /api/contract/${contractId}/comments/${commentId}`);
      await new Promise((r) => setTimeout(r, 300));
    },
    ...options?.mutation,
  });
};

// TODO: Replace with real hook when POST /api/contract/:id/send-mail exists with new contract API
export const useSendContractMail = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<void, TError, { contractId: string; alternativeEmail?: string }, TContext>;
  },
): UseMutationReturnType<void, TError, { contractId: string; alternativeEmail?: string }, TContext> => {
  return useMutation({
    mutationFn: async ({ contractId, alternativeEmail }: { contractId: string; alternativeEmail?: string }) => {
      console.warn(`[STUB] POST /api/contract/${contractId}/send-mail`, { alternativeEmail });
      await new Promise((r) => setTimeout(r, 500));
    },
    ...options?.mutation,
  });
};

// TODO: Replace with real validation when backend supports checking active contracts per unit
export const useCheckUnitActiveContract = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<boolean, TError, { unitId: string }, TContext>;
  },
): UseMutationReturnType<boolean, TError, { unitId: string }, TContext> => {
  return useMutation({
    mutationFn: async ({ unitId }: { unitId: string }) => {
      console.warn(`[STUB] GET /api/unit/${unitId}/has-active-contract`);
      await new Promise((r) => setTimeout(r, 200));
      return false;
    },
    ...options?.mutation,
  });
};
